<template>
  <div class="doctorSwiper">
    <div class="swiper-container banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide"
             v-for="(item,index) in doctorArr"
             :key="index">
          <img class="doctorSwiper-img"
               :src="item.imgUrl"
               alt="">
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banner: null,
    };
  },
  computed: {
    doctorArr() {
      if (this.$store.state.screenWidth > 900) {
        return [
          {
            imgUrl:
              "https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/banner%402x.png",
          },
          {
            imgUrl:
              "https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/lmhbanner%EF%BC%8801%EF%BC%89.png",
          },
        ];
      } else {
        return [
          {
            imgUrl:
              " https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/phoneh5/home/homezls%402x.png",
          },
          {
            imgUrl:
              " https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/phoneh5/home/homelb1%402x.png",
          },
        ];
      }
    },
  },
  mounted() {
    if (!this.banner) {
      this.initSwiper();
    }
  },
  methods: {
    initSwiper() {
      this.$store.dispatch("getSwiper", () => {
        // 广告轮播图
        this.banner = new Swiper(".banner", {
          loop: true,
          autoHeight: true,
          autoplay: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
          },
        });
      });
    },
  },
};
</script>
<style lang="less">
@import url("../../../static/css/fontSize.less");
.doctorSwiper {
  .doctorSwiper-img {
    width: 100%;
  }
  .swiper-pagination-bullet {
    width: 13px;
    height: 13px;
    background: url("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/diankon%402x.png");
  }
  .swiper-pagination-bullet-active {
    background: url("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/dianbai%402x.png");
  }
  @media screen and (max-width: 900px) {
    .swiper-button-next,
    .swiper-button-prev {
      display: none;
    }
  }
  @media screen and (min-width: 900px) {
    .swiper-button-next {
      background: url("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/butzuo%402x.png");
      right: 360px;
    }
    .swiper-button-prev {
      background: url("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/butyou%402x.png");
      left: 360px;
    }
    .swiper-button-next,
    .swiper-button-prev {
      width: 50px;
      height: 50px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/doctorSwiper/doctorSwiper.vue